var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',{staticClass:"notification is-danger field"},[_c('button',{staticClass:"delete",on:{"click":function($event){_vm.error = null}}}),_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }